import React from "react";

import { Divider, Button, Loading } from "../Controls";

import texts from "../../assets/strings/bummer.js";
import { hashHistory } from "react-router";

const BummerMobile = props => {
  const firstName = props.reducer.target.firstName[0].value;
  return (
    <div className="confirmation mobile">
      <h1 style={{ fontSize: 35 }}>{texts.title}</h1>
      <h2 style={{ margin: 25, lineHeight: 1.5 }}>
        {texts.h1.replace("{{firstName}}", firstName)}
      </h2>
      <div className="note">{texts.h3.replace("{{firstName}}", firstName)}</div>
      <div className="note">
        <Button
          primary={true}
          large={true}
          onClick={() => window.location.reload()}
        >
          <span>{texts.done}</span>
        </Button>
      </div>
    </div>
  );
};
export default BummerMobile;



// WEBPACK FOOTER //
// ./components/Review/BummerMobile.js